export default __webpack_public_path__ + "static/media/product_banner_SD-WAN.ff59e7e7.png";